module.exports = __webpack_public_path__ + "media/assets/img/flags/sl-SI-cf981f1848d2dff9b0e8564144f135a0.png";